import { FC } from "react";
import { AreaItemStyled } from "./style";

interface AreaListPreviewItemProps {
    areaName: string
}

export const AreaItem: FC<AreaListPreviewItemProps> = ({
    areaName
}) => {
    return (
        <AreaItemStyled>
            <span>{areaName}</span>
        </AreaItemStyled>
    )
}